export default __webpack_public_path__ + "static/media/callTimes.768db398.svg";